import { createFileRoute } from "@tanstack/react-router";
import LawnMowerGuide from "@/pages/LawnMowerGuide";

export const Route = createFileRoute("/lawn-mower-guide")({
  component: LawnMowerGuide,
});
